import { mergeLeftOnly } from 'merge-left-utils'
import React, { forwardRef, useCallback } from 'react'
import { ReactSortable } from 'react-sortablejs'
import { Panel } from 'rsuite'
import { ShopStateType } from '../ShopFormState'
import { ProductImageGalleryItem, ShopImage } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import DropzoneUploader from '@components/common/form/DropzoneUploader'
import { UPLOAD_NAME_PRODUCT_PREVIEW } from '@@partner:config/product'
import { UPLOAD_NAME_SHOP_IMAGE } from '@@partner:config/shop'
import { API_URL_UPLOAD_SHOP_IMAGE } from '@@partner:config/api'

interface props {
  formState: ShopStateType
  setFormState: (state: ShopStateType) => void
}


const CustomComponent = forwardRef<HTMLDivElement, any>((props, ref) => {
  return <div ref={ref} style={{ flexDirection: 'row'}}>{props.children}</div>
})

export default function ShopImages ({
  formState,
  setFormState
}: props) {

  const handleProductImageGalleryUploaded = useCallback(
    (preview_id, url) => {
      setFormState((state) =>
        mergeLeftOnly([ 'images' ], state, {
          images: [
            ...state.images,
            {
              id: preview_id,
              url,
              weight: state.images.length > 0 ? Math.max(...state.images.map(image => image.weight)) + 1 : 5
            }
          ]
        })
      )
    }, [ setFormState ]
  )

  const handleProductImagesOrderChanged = useCallback(
    (newState: ShopImage[]) => {
      setFormState((state) => 
        mergeLeftOnly([ 'images' ], state, {
          images: newState.map((image, index) => ({
            id: image.id,
            url: image.url,
            weight: 5 + index
          }))
        })
      )
    }, [ setFormState ]
  )

  return (
    <Panel
      shaded
      header='Галерея'
      className='my-5'
    >
      <ReactSortable
        direction={'horizontal'}
        tag={CustomComponent}
        list={formState.images} 
        setList={handleProductImagesOrderChanged}
      >
        {formState.images.map((item) => (
          <img 
            key={`image:${item.id}`} 
            className={'w-32 block'} 
            style={{ display: 'inline-block'}}
            src={item.url.replace('https://0ffc-89-179-65-42.eu.ngrok.io', 'http://localhost:12097')} 
          />
        ))}
        <DropzoneUploader
          name={UPLOAD_NAME_SHOP_IMAGE}
          action={API_URL_UPLOAD_SHOP_IMAGE}
          onUploaded={handleProductImageGalleryUploaded}
          multiple={false}
        />
      </ReactSortable>
    </Panel>
  )
}